import React from "react";
import * as R from "ramda";
import {FormatCurrencyWithoutSymbol} from "../../../../Services/Utils";
import { TableCell } from "@material-ui/core";

export const getTableConfigDaily = (tab) => {
    return tableConfigDaily[tab];
}

const tableConfigDaily = {
    cash: [
        [
            {
                name: "",
                label: "No",
                options: {
                    customBodyRender: (_, tableMeta) => {
                        const {page, rowsPerPage} = tableMeta.tableState;
                        const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                        return <>{rowNumber}</>;
                    },
                },
            },
            {
                name: "tanggalPayment",
                label: "Tanggal BKM",
            },
            {
                name: "paymentId",
                label: "No. BKM"
            },
            {
                name: "nominalBelumRealisasi",
                label: "Nominal Belum Realisasi (Rp)",
                options: {
                    customBodyRender: (val) => {
                        return !R.isNil(val) ? FormatCurrencyWithoutSymbol({number: val}) : "";
                    }
                }
            },
            {
                name: "nominalRealisasi",
                label: "Nominal Sudah Realisasi (Rp)",
                options: {
                    customBodyRender: (val) => {
                        return !R.isNil(val) ? FormatCurrencyWithoutSymbol({number: val}) : "";
                    }
                }
            },
        ],
        [
            {
                name: "",
                label: "No",
                options: {
                    customBodyRender: (_, tableMeta) => {
                        const {page, rowsPerPage} = tableMeta.tableState;
                        const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                        return <>{rowNumber}</>;
                    },
                },
            },
            {
                name: "tanggalPayment",
                label: "Tanggal BKK",
            },
            {
                name: "paymentId",
                label: "No. BKK"
            },
            {
                name: "nominalBelumRealisasi",
                label: "Nominal Belum Realisasi (Rp)",
                options: {
                    customBodyRender: (val) => {
                        return !R.isNil(val) ? FormatCurrencyWithoutSymbol({number: val}) : "";
                    }
                }
            },
            {
                name: "nominalRealisasi",
                label: "Nominal Sudah Realisasi (Rp)",
                options: {
                    customBodyRender: (val) => {
                        return !R.isNil(val) ? FormatCurrencyWithoutSymbol({number: val}) : "";
                    }
                }
            },
        ],
    ],
    bank: [
        [
            {
                name: "",
                label: "No",
                options: {
                    customBodyRender: (_, tableMeta) => {
                        const {page, rowsPerPage} = tableMeta.tableState;
                        const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                        return <>{rowNumber}</>;
                    },
                },
            },
            {
                name: "tanggalPayment",
                label: "Tanggal BBM",
            },
            {
                name: "paymentId",
                label: "No. BBM"
            },
            {
                name: "nominalBelumRealisasi",
                label: "Nominal Belum Realisasi (Rp)",
                options: {
                    customBodyRender: (val) => {
                        return !R.isNil(val) ? FormatCurrencyWithoutSymbol({number: val}) : "";
                    }
                }
            },
            {
                name: "nominalRealisasi",
                label: "Nominal Sudah Realisasi (Rp)",
                options: {
                    customBodyRender: (val) => {
                        return !R.isNil(val) ? FormatCurrencyWithoutSymbol({number: val}) : "";
                    }
                }
            },
        ],
        [
            {
                name: "",
                label: "No",
                options: {
                    customBodyRender: (_, tableMeta) => {
                        const {page, rowsPerPage} = tableMeta.tableState;
                        const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                        return <>{rowNumber}</>;
                    },
                },
            },
            {
                name: "tanggalPayment",
                label: "Tanggal BBK",
            },
            {
                name: "paymentId",
                label: "No. BBK"
            },
            {
                name: "nominalBelumRealisasi",
                label: "Nominal Belum Realisasi (Rp)",
                options: {
                    customBodyRender: (val) => {
                        return !R.isNil(val) ? FormatCurrencyWithoutSymbol({number: val}) : "";
                    }
                }
            },
            {
                name: "nominalRealisasi",
                label: "Nominal Sudah Realisasi (Rp)",
                options: {
                    customBodyRender: (val) => {
                        return !R.isNil(val) ? FormatCurrencyWithoutSymbol({number: val}) : "";
                    }
                }
            },
        ],
    ],
};

export const generateYearOptions = (startYear = 1970, endYear = new Date().getFullYear()) => {
    const years = [];
    for (let year = endYear; year >= startYear; year--) {
        years.push({label: year, value: year});
    }
    return years;
};

export const monthOptions = [
    {label: "Januari", value: 1},
    {label: "Februari", value: 2},
    {label: "Maret", value: 3},
    {label: "April", value: 4},
    {label: "Mei", value: 5},
    {label: "Juni", value: 6},
    {label: "Juli", value: 7},
    {label: "Agustus", value: 8},
    {label: "September", value: 9},
    {label: "Oktober", value: 10},
    {label: "November", value: 11},
    {label: "Desember", value: 12},
];

export const getTableConfigSpecific = (tab) => {
    return tableConfigSpecific[tab];
};

const formatRupiah = (value) => {
  const number = Number(value) || 0;

  return number.toLocaleString("id-ID", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
};

const centerHeader = (label) => (
    <TableCell align="center">
        {label}
    </TableCell>
);

const tableConfigSpecific = {
    bkm: [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const {page, rowsPerPage} = tableMeta.tableState;
                    const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                    return <>{rowNumber}</>;
                },
            },
        },
        {
            name: "kodeKas",
            label: "Kode Kas",
        },
        {
            name: "tanggalPayment",
            label: "Tanggal BKM",
        },
        {
            name: "paymentId",
            label: "No BKM",
        },
        {
            name: "nominal",
            label: "Nominal",
            options: {
                customBodyRender: (val) => {
                    return formatRupiah(val);
                }
            }
        },
        {
            name: "statusPayment",
            label: "Belum Realisasi",
            options: {
                customHeadRender: ({ label }) => (
                    <TableCell align="center">
                        {label}
                    </TableCell>
                ),
                setCellProps: () => ({
                    style: { textAlign: "center" }
                }),
                customBodyRender: (val) =>
                    val === "BELUM_REALISASI" ? "þ" : ""
            }
        },
        {
            name: "statusPayment",
            label: "Sudah Realisasi",
            options: {
                customHeadRender: ({ label }) => (
                    <TableCell align="center">
                        {label}
                    </TableCell>
                ),
                setCellProps: () => ({
                    style: { textAlign: "center" }
                }),
                customBodyRender: (val) =>
                    val === "REALISASI" ? "þ" : ""
            }
        },
        {
            name: "printStatus",
            label: "Sudah Dicetak",
            options: {
                customHeadRender: ({ label }) => (
                    <TableCell align="center">
                        {label}
                    </TableCell>
                ),
                setCellProps: () => ({
                    style: { textAlign: "center" }
                }),
                customBodyRender: (val) =>
                    val === "SUDAH_DICETAK" ? "þ" : ""
            }
        },
        {
            name: "statusPayment",
            label: "Batal",
            options: {
                customHeadRender: ({ label }) => (
                    <TableCell align="center">
                        {label}
                    </TableCell>
                ),
                setCellProps: () => ({
                    style: { textAlign: "center" }
                }),
                customBodyRender: (val) =>
                    val === "BATAL" ? "þ" : ""
            }
        },
    ],
    bkk: [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const {page, rowsPerPage} = tableMeta.tableState;
                    const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                    return <>{rowNumber}</>;
                },
            },
        },
        {
            name: "kodeKas",
            label: "Kode Kas",
        },
        {
            name: "tanggalPayment",
            label: "Tanggal BKK",
        },
        {
            name: "paymentId",
            label: "No BKK",
        },
        {
            name: "nominal",
            label: "Nominal",
            options: {
                customBodyRender: (val) => {
                    return formatRupiah(val);
                }
            }
        },
        {
            name: "statusPayment",
            label: "Belum Realisasi",
            options: {
                customHeadRender: ({ label }) => (
                    <TableCell align="center">
                        {label}
                    </TableCell>
                ),
                setCellProps: () => ({
                    style: { textAlign: "center" }
                }),
                customBodyRender: (val) =>
                    val === "BELUM_REALISASI" ? "þ" : ""
            }
        },
        {
            name: "statusPayment",
            label: "Sudah Realisasi",
            options: {
                customHeadRender: ({ label }) => (
                    <TableCell align="center">
                        {label}
                    </TableCell>
                ),
                setCellProps: () => ({
                    style: { textAlign: "center" }
                }),
                customBodyRender: (val) =>
                    val === "REALISASI" ? "þ" : ""
            }
        },
        {
            name: "printStatus",
            label: "Sudah Dicetak",
            options: {
                customHeadRender: ({ label }) => (
                    <TableCell align="center">
                        {label}
                    </TableCell>
                ),
                setCellProps: () => ({
                    style: { textAlign: "center" }
                }),
                customBodyRender: (val) =>
                    val === "SUDAH_DICETAK" ? "þ" : ""
            }
        },
        {
            name: "statusPayment",
            label: "Batal",
            options: {
                customHeadRender: ({ label }) => (
                    <TableCell align="center">
                        {label}
                    </TableCell>
                ),
                setCellProps: () => ({
                    style: { textAlign: "center" }
                }),
                customBodyRender: (val) =>
                    val === "BATAL" ? "þ" : ""
            }
        },
    ],
    bbm: [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const {page, rowsPerPage} = tableMeta.tableState;
                    const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                    return <>{rowNumber}</>;
                },
            },
        },
        {
            name: "bankCode",
            label: "Kode Bank",
        },
        {
            name: "tanggalPayment",
            label: "Tanggal BBM",
        },
        {
            name: "paymentId",
            label: "No BBM",
        },
        {
            name: "nominal",
            label: "Nominal",
            options: {
                customBodyRender: (val) => {
                    return formatRupiah(val);
                }
            }
        },
        {
            name: "statusPayment",
            label: "Belum Realisasi",
            options: {
                customHeadRender: ({ label }) => (
                    <TableCell align="center">
                        {label}
                    </TableCell>
                ),
                setCellProps: () => ({
                    style: { textAlign: "center" }
                }),
                customBodyRender: (val) =>
                    val === "BELUM_REALISASI" ? "þ" : ""
            }
        },
        {
            name: "statusPayment",
            label: "Sudah Realisasi",
            options: {
                customHeadRender: ({ label }) => (
                    <TableCell align="center">
                        {label}
                    </TableCell>
                ),
                setCellProps: () => ({
                    style: { textAlign: "center" }
                }),
                customBodyRender: (val) =>
                    val === "REALISASI" ? "þ" : ""
            }
        },
        {
            name: "printStatus",
            label: "Sudah Dicetak",
            options: {
                customHeadRender: ({ label }) => (
                    <TableCell align="center">
                        {label}
                    </TableCell>
                ),
                setCellProps: () => ({
                    style: { textAlign: "center" }
                }),
                customBodyRender: (val) =>
                    val === "SUDAH_DICETAK" ? "þ" : ""
            }
        },
        {
            name: "statusPayment",
            label: "Batal",
            options: {
                customHeadRender: ({ label }) => (
                    <TableCell align="center">
                        {label}
                    </TableCell>
                ),
                setCellProps: () => ({
                    style: { textAlign: "center" }
                }),
                customBodyRender: (val) =>
                    val === "BATAL" ? "þ" : ""
            }
        },
    ],
    bbk: [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const {page, rowsPerPage} = tableMeta.tableState;
                    const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                    return <>{rowNumber}</>;
                },
            },
        },
        {
            name: "bankCode",
            label: "Kode Bank",
        },
        {
            name: "tanggalPayment",
            label: "Tanggal BBK",
        },
        {
            name: "paymentId",
            label: "No BBK",
        },
        {
            name: "nominal",
            label: "Nominal",
            options: {
                customBodyRender: (val) => {
                    return formatRupiah(val);
                }
            }
        },
        {
            name: "statusPayment",
            label: "Belum Realisasi",
            options: {
                customHeadRender: ({ label }) => (
                    <TableCell align="center">
                        {label}
                    </TableCell>
                ),
                setCellProps: () => ({
                    style: { textAlign: "center" }
                }),
                customBodyRender: (val) =>
                    val === "BELUM_REALISASI" ? "þ" : ""
            }
        },
        {
            name: "statusPayment",
            label: "Sudah Realisasi",
            options: {
                customHeadRender: ({ label }) => (
                    <TableCell align="center">
                        {label}
                    </TableCell>
                ),
                setCellProps: () => ({
                    style: { textAlign: "center" }
                }),
                customBodyRender: (val) =>
                    val === "REALISASI" ? "þ" : ""
            }
        },
        {
            name: "printStatus",
            label: "Sudah Dicetak",
            options: {
                customHeadRender: ({ label }) => (
                    <TableCell align="center">
                        {label}
                    </TableCell>
                ),
                setCellProps: () => ({
                    style: { textAlign: "center" }
                }),
                customBodyRender: (val) =>
                    val === "SUDAH_DICETAK" ? "þ" : ""
            }
        },
        {
            name: "statusPayment",
            label: "Batal",
            options: {
                customHeadRender: ({ label }) => (
                    <TableCell align="center">
                        {label}
                    </TableCell>
                ),
                setCellProps: () => ({
                    style: { textAlign: "center" }
                }),
                customBodyRender: (val) =>
                    val === "BATAL" ? "þ" : ""
            }
        },
    ],
};